<header app-main-header></header>
<toolbar app-main-toolbar></toolbar>

<router-outlet></router-outlet>

<footer app-main-footer></footer>

<app-cookie-consent></app-cookie-consent>